import { render } from "./AsideList.vue?vue&type=template&id=179864ba&scoped=true&ts=true"
import script from "./AsideList.vue?vue&type=script&lang=ts"
export * from "./AsideList.vue?vue&type=script&lang=ts"

import "./AsideList.vue?vue&type=style&index=0&id=179864ba&lang=less&scoped=true"

import exportComponent from "/root/.jenkins/workspace/production-Q-saas-plat-manage-vue/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-179864ba"]])

export default __exports__